import { ADMIN_PROFILE } from '../config/Chat'

export const RICH_KINDS = ['image', 'location']

export const REPLY_LABELS = {
  image: 'Foto',
  location: 'Ubicación',
  text: 'Mensaje'
}

export const IMAGE_THUMBNAIL_MAX = 240

export const safeMediaUrl = url => (typeof url === 'string' && /^https:\/\//i.test(url) ? url : null)

const isFiniteNumber = value => typeof value === 'number' && Number.isFinite(value)

export const messageKind = message => {
  const kind = message?.kind
  if (kind === 'image' && safeMediaUrl(message.media?.url)) return 'image'
  if (kind === 'location' && isFiniteNumber(message.location?.lat) && isFiniteNumber(message.location?.lng)) {
    return 'location'
  }
  return 'text'
}

export const googleMapsUrl = location => {
  if (!isFiniteNumber(location?.lat) || !isFiniteNumber(location?.lng)) return null
  return `https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`
}

export const imageBoxSize = (media, max = IMAGE_THUMBNAIL_MAX) => {
  const width = media?.width
  const height = media?.height
  if (!isFiniteNumber(width) || !isFiniteNumber(height) || width <= 0 || height <= 0) return null
  const scale = Math.min(1, max / Math.max(width, height))
  return {
    width: Math.max(1, Math.round(width * scale)),
    height: Math.max(1, Math.round(height * scale))
  }
}

export const replySnippet = replyTo => {
  const kind = replyTo && RICH_KINDS.includes(replyTo.kind) ? replyTo.kind : 'text'
  return {
    kind,
    label: replyTo?.text || REPLY_LABELS[kind],
    thumbnail: kind === 'text' ? null : safeMediaUrl(replyTo?.thumbnail_url)
  }
}

export const quoteAuthorName = (userId, users) => {
  if (userId === ADMIN_PROFILE.user_id) return ADMIN_PROFILE.name
  const user = (users || []).find(candidate => candidate.user_id === userId)
  return user?.name || 'Usuario'
}
